import React, { SVGProps } from 'react'

import classes from '@UI/crypto_exchange/desktop/components/modals/SimpleEarnModal/SimpleEarnModal.module.scss'

export const InfoIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12 21a9 9 0 100-18 9 9 0 000 18zM10.75 8.5V6h2.5v2.5h-2.5zm0 9.5v-7h2.5v7h-2.5z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export const SpeakerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M4.002 7H16l4-4v16l-4-4h-4v6H7v-6H4.002V7z" fill="currentColor"></path>
    </svg>
  )
}

export const PlusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M13.5 3h-3v7.5H3v3h7.5V21h3v-7.5H21v-3h-7.5V3z"></path>
    </svg>
  )
}
export const MinusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 24 24" fill="none" {...props}>
      <path d="M3 10.5v3h18v-3H3z" fill="currentColor"></path>
    </svg>
  )
}

export const MarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M7.035 16.812l-.001.002 2.121 2.121.002-.002 2.121-2.12 9.19-9.192-2.12-2.121-9.191 9.19-3.536-3.534-2.121 2.12 3.535 3.536z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export const ExclamationMarkIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12.011 2H12C6.472 2 2 6.472 2 12c0 5.527 4.472 10 10 10 5.516 0 9.988-4.473 10-9.989.012-5.527-4.461-10-9.989-10.011zm.998 16.984h-2.018v-2.007h2.018v2.007zm0-4.633h-2.018V5.005h2.018v9.346z"
        fill="currentColor"
      ></path>
    </svg>
  )
}

export const RightArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M21 11.999l-7.071-7.071-1.768 1.768 4.055 4.054H2.999v2.5h13.216l-4.054 4.053 1.768 1.768L21 12v-.001z"
        fill="currentColor"
      ></path>
    </svg>
  )
}
export const MinusCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg width="17px" height="17px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      fill="#d30000"
    />
    <path
      d="M15.9199 12.75H7.91992C7.50992 12.75 7.16992 12.41 7.16992 12C7.16992 11.59 7.50992 11.25 7.91992 11.25H15.9199C16.3299 11.25 16.6699 11.59 16.6699 12C16.6699 12.41 16.3399 12.75 15.9199 12.75Z"
      fill="#ffffff"
    />
  </svg>
)

export const EmptyListIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 144 144"
    width="144"
    height="144"
    preserveAspectRatio="xMidYMid meet"
    style={{
      transform: 'translate3d(0px, 0px, 0px)',
      contentVisibility: 'visible',
    }}
    {...props}
  >
    <defs>
      <clipPath id="__lottie_element_189">
        <rect width="144" height="144" x="0" y="0"></rect>
      </clipPath>
    </defs>
    <g clip-path="url(#__lottie_element_189)">
      <g
        transform="matrix(1,-0.00000803744751465274,0.00000803744751465274,1,58.74947738647461,50.75035095214844)"
        opacity="1"
        style={{ display: 'block' }}
      >
        <g opacity="1" transform="matrix(1,0,0,1,31.75,33.71099853515625)">
          <path
            fill="rgb(51,51,51)"
            fill-opacity="1"
            d=" M-23.48699951171875,-33.46200180053711 C-23.48699951171875,-33.46200180053711 23.48699951171875,-33.46200180053711 23.48699951171875,-33.46200180053711 C27.895999908447266,-33.46200180053711 31.5,-29.95599937438965 31.5,-25.5939998626709 C31.5,-25.5939998626709 31.5,10.958000183105469 31.5,10.958000183105469 C31.5,10.958000183105469 31.496999740600586,11.182999610900879 31.496999740600586,11.182999610900879 C31.375,15.440999984741211 27.81999969482422,18.82699966430664 23.48699951171875,18.82699966430664 C23.48699951171875,18.82699966430664 17.408000946044922,18.826000213623047 17.408000946044922,18.826000213623047 C17.408000946044922,18.826000213623047 17.408000946044922,29.23200035095215 17.408000946044922,29.23200035095215 C17.408000946044922,29.23200035095215 17.40399932861328,29.386999130249023 17.40399932861328,29.386999130249023 C17.290000915527344,31.993999481201172 14.279999732971191,33.46200180053711 12.131999969482422,31.895000457763672 C12.131999969482422,31.895000457763672 -5.7820000648498535,18.826000213623047 -5.7820000648498535,18.826000213623047 C-5.7820000648498535,18.826000213623047 -23.48699951171875,18.82699966430664 -23.48699951171875,18.82699966430664 C-27.895999908447266,18.82699966430664 -31.5,15.321000099182129 -31.5,10.958000183105469 C-31.5,10.958000183105469 -31.5,-25.5939998626709 -31.5,-25.5939998626709 C-31.5,-29.95599937438965 -27.895999908447266,-33.46200180053711 -23.48699951171875,-33.46200180053711z"
          ></path>
        </g>
      </g>
      <g
        transform="matrix(1,0.000006429957920772722,-0.000006429957920772722,1,18.75054168701172,23.24987030029297)"
        opacity="1"
        style={{ display: 'block' }}
      >
        <g opacity="1" transform="matrix(1,0,0,1,40.25,42.83700180053711)">
          <path
            fill="rgb(78,78,78)"
            fill-opacity="1"
            d=" M29.825000762939453,-42.58700180053711 C29.825000762939453,-42.58700180053711 -29.823999404907227,-42.58700180053711 -29.823999404907227,-42.58700180053711 C-35.42300033569336,-42.58700180053711 -40,-38.125 -40,-32.573001861572266 C-40,-32.573001861572266 -40,13.946000099182129 -40,13.946000099182129 C-40,13.946000099182129 -39.994998931884766,14.232999801635742 -39.994998931884766,14.232999801635742 C-39.84199905395508,19.652000427246094 -35.32600021362305,23.961000442504883 -29.823999404907227,23.961000442504883 C-29.823999404907227,23.961000442504883 -22.104999542236328,23.959999084472656 -22.104999542236328,23.959999084472656 C-22.104999542236328,23.959999084472656 -22.104999542236328,37.20600128173828 -22.104999542236328,37.20600128173828 C-22.104999542236328,37.20600128173828 -22.10099983215332,37.40299987792969 -22.10099983215332,37.40299987792969 C-21.954999923706055,40.720001220703125 -18.132999420166016,42.58700180053711 -15.404999732971191,40.59299850463867 C-15.404999732971191,40.59299850463867 7.3429999351501465,23.959999084472656 7.3429999351501465,23.959999084472656 C7.3429999351501465,23.959999084472656 29.825000762939453,23.961000442504883 29.825000762939453,23.961000442504883 C35.42300033569336,23.961000442504883 40,19.499000549316406 40,13.946000099182129 C40,13.946000099182129 40,-32.573001861572266 40,-32.573001861572266 C40,-38.125 35.42300033569336,-42.58700180053711 29.825000762939453,-42.58700180053711z"
          ></path>
        </g>
      </g>
      <g transform="matrix(1,0,0,1,40.108001708984375,42.15299987792969)" opacity="1" style={{ display: 'block' }}>
        <g opacity="1" transform="matrix(1,0,0,1,19.038000106811523,16.427000045776367)">
          <path
            fill="rgb(212,160,119)"
            fill-opacity="1"
            d=" M-0.0010000000474974513,16.17799949645996 C-0.0010000000474974513,16.17799949645996 -15.34000015258789,-0.08299999684095383 -15.34000015258789,-0.08299999684095383 C-18.10300064086914,-2.8889999389648438 -18.788999557495117,-7.176000118255615 -17.04199981689453,-10.72599983215332 C-15.73799991607666,-13.376999855041504 -13.258000373840332,-15.229000091552734 -10.378000259399414,-15.704000473022461 C-7.499000072479248,-16.17799949645996 -4.570000171661377,-15.218000411987305 -2.506999969482422,-13.121999740600586 C-2.506999969482422,-13.121999740600586 -0.0010000000474974513,-10.57699966430664 -0.0010000000474974513,-10.57699966430664 C-0.0010000000474974513,-10.57699966430664 2.506999969482422,-13.121999740600586 2.506999969482422,-13.121999740600586 C4.570000171661377,-15.218000411987305 7.498000144958496,-16.17799949645996 10.378000259399414,-15.704000473022461 C13.258000373840332,-15.229000091552734 15.73799991607666,-13.376999855041504 17.04199981689453,-10.72599983215332 C18.788999557495117,-7.176000118255615 18.10300064086914,-2.8889999389648438 15.34000015258789,-0.08299999684095383 C15.34000015258789,-0.08299999684095383 -0.0010000000474974513,16.17799949645996 -0.0010000000474974513,16.17799949645996z"
          ></path>
        </g>
      </g>
    </g>
  </svg>
)
